import React, { useEffect } from 'react'
import { Bars } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRestaurants, updateFilterOptions, updatePageNumber } from '../../redux/actions/restaurantsListAction';
import RestaurantItem from '../RestaurantItem/RestaurantItem';
import "./RestaurantsList.css";
import { Form } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { sortByOptions } from '../../redux/constants';

function RestaurantsList() {
    const dispatch = useDispatch();
    const store = useSelector(store => {
        return store.restaurantsReducer
    });

    const itemsPerPage = store.itemsPerPage;
    const pageCount = Math.ceil(store.totalCount / itemsPerPage);

    const handlePageClick = (event) => {
        dispatch(updatePageNumber(event.selected))

        dispatch(fetchRestaurants({
            offset: (event.selected) * itemsPerPage,
            limit: itemsPerPage,
            sortBy: store.sortBy
        }))
    };

    
    const onChangeSortoption = (e) => {
        dispatch(updateFilterOptions(e.target.value))
        
        dispatch(fetchRestaurants({
            offset: (store.currentPageNumber) * itemsPerPage,
            limit: itemsPerPage,
            sortBy: e.target.value
        }))
    }
    
    const getRestaurantsList = () => {
        dispatch(fetchRestaurants({
            offset: 0,
            limit: itemsPerPage,
            sortBy: store.sortBy
        }))
    }
    
    useEffect(() => {
        getRestaurantsList()
    }, [])

    const renderLoader = () => {
        if (store.loading) {
            return (
                <Bars
                    height="100vh"
                    width="80"
                    color="#f7931e"
                    ariaLabel="bars-loading"
                    wrapperStyle={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                    wrapperClass=""
                    visible={true}
                />
            )
        } else {
            return <></>
        }
    }

    return (
        <div className='restaurants-main-container'>
            {renderLoader()}
            <h1>Popular Restaurants</h1>
            <div className='restaurants-filter-container'>
                <p>Select Your favourite restaurant special dish and make your day happy...</p>
                <div className='d-flex align-items-center'>
                    <i className="fa-solid fa-filter me-2"></i>
                    <Form.Select className="yummy-select-field" onChange={onChangeSortoption} value={store.sortBy}>
                        {sortByOptions.map(item => <option>{item.displayText}</option>)}
                    </Form.Select>
                </div>
            </div>

            <div className='restaurants-list-container'>
                {
                    store.restaurants.map((restaurant) => <RestaurantItem key={restaurant.id} restaurant={restaurant} />)
                }
            </div>

            <div className='d-flex justify-content-center mt-3 mb-3'>
                <ReactPaginate
                    // nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    // previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                />
            </div>
        </div>
    )
}

export default RestaurantsList